/** A coach is not in `players`, but can be booked: card events carry a
 *  synthetic player id per side. For the card counters a coach is treated
 *  like a substitute on the bench — counted in cards_*, never in sent_off. */
export const COACH_PLAYER_IDS = { home: "coach_home", away: "coach_away" } as const;

export function coachPlayerId(side: "home" | "away"): string {
  return COACH_PLAYER_IDS[side];
}

export function coachSide(playerId: string | null | undefined): "home" | "away" | null {
  if (playerId === COACH_PLAYER_IDS.home) return "home";
  if (playerId === COACH_PLAYER_IDS.away) return "away";
  return null;
}

export function isCardEventType(type: string): boolean {
  return type === "yellow_card" || type === "second_yellow" || type === "red_card";
}
